// export const API_HOST = 'http://192.168.100.15:81/api';
// export const API_HOST = 'http://xfbus.itimebus.cn/api';
// export const API_HOST = 'http://www.itimebus.com.cn/api';

// export const API_HOST = 'http://xddbus.evcas.com/api';//爱电阿里云服务地址
export const API_HOST = 'http://app.ahxdbus.cn/api';//鑫大道自己服务器